/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AdminUsersApi } from './services/admin-users-api';
import { AuditLogsApi } from './services/audit-logs-api';
import { AuthenticationApi } from './services/authentication-api';
import { BudgetVersionsApi } from './services/budget-versions-api';
import { BudgetsApi } from './services/budgets-api';
import { CashflowApi } from './services/cashflow-api';
import { CostTypesApi } from './services/cost-types-api';
import { CostStatisticsApi } from './services/cost-statistics-api';
import { CostflowApi } from './services/costflow-api';
import { CurrentConfigurationApi } from './services/current-configuration-api';
import { CustomFieldsSchemaApi } from './services/custom-fields-schema-api';
import { DiagnosticsApi } from './services/diagnostics-api';
import { EffectiveBasicCostApi } from './services/effective-basic-cost-api';
import { EffectiveCostApi } from './services/effective-cost-api';
import { EffectiveLaborCostApi } from './services/effective-labor-cost-api';
import { EffectiveRevenueApi } from './services/effective-revenue-api';
import { EstimatedBasicCostApi } from './services/estimated-basic-cost-api';
import { EstimatedCostApi } from './services/estimated-cost-api';
import { EstimatedLaborCostApi } from './services/estimated-labor-cost-api';
import { EstimatedRevenueApi } from './services/estimated-revenue-api';
import { FileSystemApi } from './services/file-system-api';
import { FilesApi } from './services/files-api';
import { FocoosAiApi } from './services/focoos-ai-api';
import { GlobalConfigurationsApi } from './services/global-configurations-api';
import { GroupsApi } from './services/groups-api';
import { InventoryItemsApi } from './services/inventory-items-api';
import { InventoryTransactionsApi } from './services/inventory-transactions-api';
import { LaborActivitiesApi } from './services/labor-activities-api';
import { LaborCostLogsApi } from './services/labor-cost-logs-api';
import { LaborCostsApi } from './services/labor-costs-api';
import { MembershipsApi } from './services/memberships-api';
import { NotificationsApi } from './services/notifications-api';
import { PlannedLaborCostsApi } from './services/planned-labor-costs-api';
import { PlannedUnitCostsApi } from './services/planned-unit-costs-api';
import { ProjectsApi } from './services/projects-api';
import { PushSubscriptionsApi } from './services/push-subscriptions-api';
import { RolesApi } from './services/roles-api';
import { StorageObjectsApi } from './services/storage-objects-api';
import { SuperviselyApi } from './services/supervisely-api';
import { TeamPlannersApi } from './services/team-planners-api';
import { TemplatesApi } from './services/templates-api';
import { TenantsApi } from './services/tenants-api';
import { UnitCostLogsApi } from './services/unit-cost-logs-api';
import { UnitCostsApi } from './services/unit-costs-api';
import { UserConfigurationsApi } from './services/user-configurations-api';
import { UsersApi } from './services/users-api';
import { WorkPackageCategoriesApi } from './services/work-package-categories-api';
import { WorkPackageDependenciesApi } from './services/work-package-dependencies-api';
import { WorkPackagePrioritiesApi } from './services/work-package-priorities-api';
import { WorkPackageStatusesApi } from './services/work-package-statuses-api';
import { WorkPackageTypesApi } from './services/work-package-types-api';
import { WorkPackageFieldsSchemaApi } from './services/work-package-fields-schema-api';
import { WorkPackagesApi } from './services/work-packages-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AdminUsersApi,
    AuditLogsApi,
    AuthenticationApi,
    BudgetVersionsApi,
    BudgetsApi,
    CashflowApi,
    CostTypesApi,
    CostStatisticsApi,
    CostflowApi,
    CurrentConfigurationApi,
    CustomFieldsSchemaApi,
    DiagnosticsApi,
    EffectiveBasicCostApi,
    EffectiveCostApi,
    EffectiveLaborCostApi,
    EffectiveRevenueApi,
    EstimatedBasicCostApi,
    EstimatedCostApi,
    EstimatedLaborCostApi,
    EstimatedRevenueApi,
    FileSystemApi,
    FilesApi,
    FocoosAiApi,
    GlobalConfigurationsApi,
    GroupsApi,
    InventoryItemsApi,
    InventoryTransactionsApi,
    LaborActivitiesApi,
    LaborCostLogsApi,
    LaborCostsApi,
    MembershipsApi,
    NotificationsApi,
    PlannedLaborCostsApi,
    PlannedUnitCostsApi,
    ProjectsApi,
    PushSubscriptionsApi,
    RolesApi,
    StorageObjectsApi,
    SuperviselyApi,
    TeamPlannersApi,
    TemplatesApi,
    TenantsApi,
    UnitCostLogsApi,
    UnitCostsApi,
    UserConfigurationsApi,
    UsersApi,
    WorkPackageCategoriesApi,
    WorkPackageDependenciesApi,
    WorkPackagePrioritiesApi,
    WorkPackageStatusesApi,
    WorkPackageTypesApi,
    WorkPackageFieldsSchemaApi,
    WorkPackagesApi,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
